import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import { useExpandedScreenContext } from '@/shared/ThemeDetail/ExpandedScreen/ExpandedScreenContext';
import { useContext } from 'react';
import useIsMobile from '@/hooks/useIsMobile';

export default function useMaximizeScreen() {
  const fullscreenContext = useContext(FullscreenContext);
  const expandedScreenContext = useExpandedScreenContext();

  const isMobile = useIsMobile();

  return {
    maximize: () => {
      if (expandedScreenContext.actions && !isMobile) {
        expandedScreenContext.actions.setActive(true);
      } else {
        fullscreenContext.actions.setFullscreen(true);
      }
    },
    minimize: () => {
      if (expandedScreenContext.actions && !isMobile) {
        expandedScreenContext.actions.setActive(false);
      } else {
        fullscreenContext.actions.setFullscreen(false);
      }
    },
    isMaximized:
      expandedScreenContext.state && !isMobile
        ? expandedScreenContext.state.active
        : fullscreenContext.state.isFullscreen,
  };
}
